import {creates, hoistCmp} from '@xh/hoist/core';
import {DistributionsModel} from './DistributionsModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {toolbar, toolbarSep} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {groupingChooser} from '@xh/hoist/desktop/cmp/grouping';
import {Icon} from '@xh/hoist/icon';
import './Distributions.scss';
import {addDistributionDialog} from './AddDistributionDialog';
import {maximizeIcon, minimizeIcon} from '../../../../core/Icons';

export const distributions = hoistCmp.factory({
    model: creates(DistributionsModel),
    render({model}) {
        return panel({
            tbar: tbar(),
            items: [grid(), addDistributionDialog({model: model.addDistributionDialog})],
            mask: model.apiTask
        });
    }
});

const tbar = hoistCmp.factory<DistributionsModel>(({model}) =>
    toolbar(
        button({icon: Icon.add(), text: 'Add', intent: 'primary', onClick: () => model.addNew()}),
        toolbarSep(),
        groupingChooser({
            icon: Icon.treeList(),
            rightIcon: !model.isGrouped
                ? null
                : button({
                      icon: Icon.x(),
                      height: 20,
                      minHeight: 20,
                      onClick: e => {
                          model.ungroup();
                          e.stopPropagation();
                          e.preventDefault();
                      }
                  }),
            model: model.groupingChooserModel
        }),
        button({
            icon: maximizeIcon(),
            text: 'Expand All',
            disabled: !model.isGrouped,
            onClick: () => model.expand()
        }),
        button({
            icon: minimizeIcon(),
            text: 'Collapse All',
            disabled: !model.isGrouped,
            onClick: () => model.collapse()
        }),
        button({
            icon: Icon.refresh(),
            text: 'Refresh',
            onClick: () => model.refresh()
        })
    )
);
